import { createApp, markRaw } from 'vue';
import { createHead } from '@unhead/vue/client';
import { DeprecationsPlugin, TemplateParamsPlugin } from '@unhead/vue/plugins';
import { createPinia } from 'pinia';
import router from './router';
import { initAxios } from '@/plugins/axios';
import { initDatadog } from '@/plugins/datadog';
import { i18n } from '@/plugins/i18n';
import { vuetify } from '@/plugins/vuetify';
import OktaVue from '@okta/okta-vue';
import { initRemotes } from '@/plugins/mfes';
import { oktaConfig } from '@/plugins/okta';
import { initReviewApp } from '@/plugins/gitlab';
import { initMaven } from '@/plugins/maven';
import { initCustomerIo } from '@/plugins/customerio';
import { LDPlugin } from 'launchdarkly-vue-client-sdk';
import appConfig, { type InflcrAppConfig } from '@/app.config';
import '/node_modules/@teamworksdev/vuetify/dist/src/styles/main.scss';
import './styles/main.scss';
import App from './App.vue';
import { ldConfig } from './plugins/launchdarkly';
import { InfluencerWebPlugin } from './plugins/influencer';
import { queryClient } from '@/plugins/vueQuery';
import { VueQueryPlugin } from '@tanstack/vue-query';

initRemotes();
initAxios();
initDatadog();
initMaven();
initCustomerIo();

const app = createApp(App);
const pinia = createPinia();
pinia.use(({ store }) => {
	store.$router = markRaw(router);
});



app.use(LDPlugin, ldConfig);
app.use(pinia);
app.use(router);
app.use(createHead({
	plugins: [TemplateParamsPlugin, DeprecationsPlugin],
}));
app.use(i18n);
app.use(vuetify);
app.use(OktaVue, oktaConfig);
app.use(InfluencerWebPlugin);
app.use(VueQueryPlugin, { queryClient });
app.provide<InflcrAppConfig>('appConfig', appConfig);
app.mount('#app');

initReviewApp();
